export enum ErrorCodes {
  ERR_EMAIL_IN_USE = 226,
  ERR_PHONE_EXISTS = 226,
  ERR_DOMAIN_NOT_ALLOWED = 403
}
